import { renderToStaticMarkup } from "react-dom/server";
import PrintPDSTable, {
  PDS_PRINT_STYLES,
} from "../../../MyProfile/components/printPDS/PrintPDSTable";

function adaptApplicantToPdsObject(employeeData = {}) {
  const employee = {
    ...employeeData,
    residentialHouseNo:
      employeeData.residentialHouseNo || employeeData.house || "",
    residentialStreet:
      employeeData.residentialStreet || employeeData.street || "",
    residentialSubdivision:
      employeeData.residentialSubdivision || employeeData.subDivision || "",
    recidentialBrangay:
      employeeData.recidentialBrangay || employeeData.barangay || "",
    recidentialCity: employeeData.recidentialCity || employeeData.city || "",
    recidentialProvince:
      employeeData.recidentialProvince || employeeData.province || "",
    residentialZipCode:
      employeeData.residentialZipCode || employeeData.zipCode || "",
    permanentHouseNo:
      employeeData.permanentHouseNo || employeeData.house1 || "",
    permanentStreet: employeeData.permanentStreet || employeeData.street1 || "",
    permanentSubdivision:
      employeeData.permanentSubdivision || employeeData.subDivision1 || "",
    permanentBrangay:
      employeeData.permanentBrangay || employeeData.barangay1 || "",
    permanentCity: employeeData.permanentCity || employeeData.city1 || "",
    permanentProvince:
      employeeData.permanentProvince || employeeData.province1 || "",
    permanentZipCode:
      employeeData.permanentZipCode || employeeData.zipCode1 || "",
    questionOne: employeeData.questionOne ?? employeeData.toggleA,
    questionTwo: employeeData.questionTwo ?? employeeData.toggleB,
    questionThree: employeeData.questionThree ?? employeeData.bulletA,
    questionFour: employeeData.questionFour ?? employeeData.bulletB,
    questionFourDate: employeeData.questionFourDate ?? employeeData.bulletBDate,
    questionFourStat: employeeData.questionFourStat ?? employeeData.bulletBStat,
    questionFive: employeeData.questionFive ?? employeeData.bulletOne,
    questionTwelve: employeeData.questionTwelve ?? employeeData.separated,
    questionSix: employeeData.questionSix ?? employeeData.bulletTwo,
    questionSeven: employeeData.questionSeven ?? employeeData.bulletThree,
    questionEight: employeeData.questionEight ?? employeeData.bulletFour,
    questionNine: employeeData.questionNine ?? employeeData.childA,
    questionTen: employeeData.questionTen ?? employeeData.childB,
    questionEleven: employeeData.questionEleven ?? employeeData.childC,
  };

  return {
    employee,
    familyBackground: employeeData.familyBackground || [],
    educationalBackground: employeeData.educationalBackground || [],
    civilServiceBackground: employeeData.civilServiceBackground || [],
    workExperienceBackground: employeeData.workExperienceBackground || [],
    voluntaryWorkBackground: (employeeData.voluntaryWorkBackground || []).map(
      (item) => ({
        ...item,
        voluntaryOrganization: item.voluntaryOrganization || item.name,
      }),
    ),
    learningDevBackground: (employeeData.learningDevBackground || []).map(
      (item) => ({
        ...item,
        learningTitle: item.learningTitle || item.learning,
      }),
    ),
    otherInformationBackground: (
      employeeData.otherInformationBackground || []
    ).map((item) => ({
      ...item,
      specialSkills: item.specialSkills || item.skill,
      recognition: item.recognition || item.academic,
    })),
    referenceBackground: employeeData.referenceBackground || [],
  };
}

export default function PrintPDS({ employeeData }) {
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";

  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;
  const printContentHTML = renderToStaticMarkup(
    PrintPDSTable({ object: adaptApplicantToPdsObject(employeeData) }),
  );

  iframeDoc.open();
  iframeDoc.write(
    `<html><head><title>Print PDS</title><style>${PDS_PRINT_STYLES}</style></head><body>`,
  );
  iframeDoc.write(printContentHTML);
  iframeDoc.write("</body></html>");
  iframeDoc.close();

  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
    }, 1000);
  };
}
